import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { RxwebValidators } from "@rxweb/reactive-form-validators";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { EncryptionService } from "src/app/services/encryption.service";
import { CommonEnums } from "src/app/utils/enum-utils";
declare var $: any;

@Component({
  selector: "app-topnavbar",
  templateUrl: "./navbar.component.html",
})
export class NavbarComponent implements OnInit {
  showSidebar: boolean = false;
  constructor(private router: Router, private _service: ApiService, private _toastr: ToastrService, private formBuilder: FormBuilder,
    private translate: TranslateService, private _commonservice: CommonService, private encrypt: EncryptionService) {
    _commonservice.myAccount.subscribe((res: any) => {
      this.currentUserData.name = res.name;
      this.currentUserData.avatarUrl = res.avatarUrl;
    })
  }

  socialLogOutUrl: string = '';
  currentUserData: any;
  pwdNotMatch: boolean = false;
  isOldPassword: boolean = false;
  isNewPassword: boolean = false;
  isConfirmPassword: boolean = false;
  selectedLanguage: any;
  password: any;
  isIncorrectOldpwd: boolean = false;
  isIncorrectOldpwdErr: any;
  CHANGE_INCORRECT_PASSWORD: any;
  PasswordNotMatch: any;
  PASSWORD_NOT_MATCH: any;
  changePwdForm: FormGroup = new FormGroup({
    oldPassword: new FormControl(''),
    password: new FormControl(''),
    newPassword: new FormControl(''),
  });
  social: any;
  mini: boolean = true;
  avatarImage: any;
  myAccountData: any;
  ngOnInit(): void {
    let social = localStorage.getItem('socialData');
    if (social) {
      this.social = JSON.parse(social);
      this.socialLogOutUrl = this.social.socialLogOutUrl
    }
    this.password = CommonEnums.password;
    let logginUserStringValue = localStorage.getItem('currentUser');
    if (logginUserStringValue) {
      this.currentUserData = JSON.parse(logginUserStringValue);
    }

    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this.translate.use(this.selectedLanguage);
    }

    this.changePwdForm = this.formBuilder.group({
      oldPassword: ['', [
        RxwebValidators.password({
          validation: {
            upperCase: true,
            lowerCase: true,
            specialCharacter: true,
            digit: true
          },
        }),
        RxwebValidators.minLength({ value: 8 }),
        RxwebValidators.maxLength({ value: 50 }),
        Validators.required
      ],],
      password: ['', [RxwebValidators.password({
        validation: {
          upperCase: true,
          lowerCase: true,
          specialCharacter: true,
          digit: true
        }
      }), RxwebValidators.minLength({ value: 8 }),
      RxwebValidators.maxLength({ value: 30 })]],
      newPassword: ['', Validators.required],
    })

  }

  goToMyAccount() {
    this.router.navigateByUrl('home/my-account')
  }


  get f(): { [key: string]: AbstractControl } {
    return this.changePwdForm.controls;
  }
  openSidebar() {
    $(".mbl-sidebar").css('width', "260px");
    $("#mbl-overlay").css({ 'background': "rgba(0,0,0,0.5)", 'width': '100%' });
    this.showSidebar = true;
  }
  closeMblSidebar() {
    this.showSidebar = false;
    $(".mbl-sidebar").css({ 'width': "0", "transition": "0.5s" });
    $("#mbl-overlay").css({ 'background': "none", 'width': '0' });
  }
  isLoading: boolean = false;

  logout() {
    this.isLoading = true;

    try {
      const sessionId = localStorage.getItem('sessionId');
      const jwtToken = localStorage.getItem('jwtToken');
      const refreshToken = this.currentUserData?.token?.refreshToken || null;

      const httpHeaders = new HttpHeaders({
        'SESSION-ID': sessionId || '',
        'Authorization': jwtToken || '',
        'Content-Type': 'application/json'
      });


      const data = { refreshToken: refreshToken };
      console.log('Logout headers:', {
        'SESSION-ID': sessionId,
        'Authorization': jwtToken
      });

      this._service.postService(this._service.API_URL.signOut, data, { headers: httpHeaders }).subscribe({
        next: (response: any) => {
          this.isLoading = false;

          if (response && response.status.code === 200) {
            this._toastr.success('', response.status.message);
            this._commonservice.getSelectedLang.next('en');

            if (this.currentUserData?.isSocialLogin && this.socialLogOutUrl) {
              const back = window.open(this.socialLogOutUrl, "_blank");
              setTimeout(() => {
                back?.close();
                this.cleanupAndRedirect();
              }, 500);
            } else {
              this.cleanupAndRedirect();
            }

          } else {
            this._toastr.error('', response?.status?.message || 'Logout failed');
            this.cleanupAndRedirect();
          }
        },
        error: (error) => {
          console.error('Logout error:', error);
          this.isLoading = false;
          this.cleanupAndRedirect();
        }
      });
    } catch (error) {
      console.error('Logout exception:', error);
      this.isLoading = false;
      this.cleanupAndRedirect();
    }
  }

  private cleanupAndRedirect() {
    localStorage.clear();
    this.router.navigateByUrl('/');
  }

  openChangePassword() {
    this.changePwdForm.reset();
    $('#changePassword').modal('show');
    this.isIncorrectOldpwdErr = null;
    this.PasswordNotMatch = null;
    this.ngOnInit();
  }

  changePassword() {
    try {
      this.isIncorrectOldpwdErr = null;
      this.PasswordNotMatch = null;
      let data = {
        "oldPassword": this.encrypt.encrypt(this.changePwdForm.controls['oldPassword'].value),
        "password": this.encrypt.encrypt(this.changePwdForm.controls['password'].value),
        "newPassword": this.encrypt.encrypt(this.changePwdForm.controls['newPassword'].value),
      }
      this._service.postService(this._service.API_URL.changeOrUpdatePassword, data).subscribe((response: any) => {

        if (response && response.status.code === 200) {
          this._toastr.success('', response.status.message);
          localStorage.clear();
          this.router.navigate(['/']);
          $('#changePassword').modal('hide');

          // this.isIncorrectOldpwd = false;
        }
        else {
          this.PASSWORD_NOT_MATCH = response.status.msgCode;
          if (this.PASSWORD_NOT_MATCH === "PASSWORD_NOT_MATCH") {
            this.PasswordNotMatch = response.status.message
          } else {
            this.isIncorrectOldpwdErr = response.status.message;
            this.PasswordNotMatch = null;

          }

          this.isIncorrectOldpwd = true;
        }

      })
    }
    catch (e) {
    }
  }
  onFocusOut() {
    if (this.changePwdForm.controls['password'].value !== this.changePwdForm.controls['newPassword'].value) {
      this.pwdNotMatch = true;
    }
    else {
      this.pwdNotMatch = false;
    }
  }

  oldPasswordNotMatch: boolean = false;
  checkOldPassword(envent: any) {
    if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['newPassword'].value) {
      this.oldPasswordNotMatch = true;
    } else {
      this.oldPasswordNotMatch = false
    }
  }

  passwordVerify(pwdType: any) {
    this.isIncorrectOldpwdErr = null;
    if (pwdType == 'new') {
      if (this.changePwdForm.controls['newPassword'].value?.length != 0 && this.changePwdForm.controls['password'].value !==
        this.changePwdForm.controls['newPassword'].value) {
        if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['password'].value && this.changePwdForm.controls['oldPassword'].value?.length > 2) {
          this.oldPasswordNotMatch = true;
          this.pwdNotMatch = false;

        }
        else {
          this.oldPasswordNotMatch = false;
          this.pwdNotMatch = true;

        }
      }
      else if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['password'].value && this.changePwdForm.controls['oldPassword'].value?.length > 2) {

        this.oldPasswordNotMatch = true;
        this.pwdNotMatch = false;

      }
      else {
        this.pwdNotMatch = false;
        this.oldPasswordNotMatch = false
      }
    }
    else {
      if (this.changePwdForm.controls['oldPassword'].value == this.changePwdForm.controls['password'].value && this.changePwdForm.controls['oldPassword'].value?.length > 2) {

        this.oldPasswordNotMatch = true;
        this.pwdNotMatch = false;

      }
      else {
        this.oldPasswordNotMatch = false;

      }
    }


  }

  closemodal() {
    this.isIncorrectOldpwdErr = null;
    this.PasswordNotMatch = null;
    this.pwdNotMatch = false;
    this.oldPasswordNotMatch = false;
    this.changePwdForm.reset();
    $('#changePassword').modal('hide');
    $('.modal-backdrop').remove();
    this.ngOnInit();
  }
  passwords: any = 'password'
  newpasswords: any = 'password'
  onClick(val: string) {
    if (val == 'oldPwd') {
      if (this.password === 'password') {
        this.password = CommonEnums.text;
        this.isOldPassword = true;
      } else {
        this.password = CommonEnums.password;
        this.isOldPassword = false;
      }
    } else if (val == 'newPwd') {
      if (this.newpasswords === 'password') {
        this.newpasswords = CommonEnums.text;
        this.isNewPassword = true;
      } else {
        this.newpasswords = CommonEnums.password;
        this.isNewPassword = false;
      }
    } else if (val == 'confPwd') {
      if (this.passwords === 'password') {
        this.passwords = CommonEnums.text;
        this.isConfirmPassword = true;

      } else {
        this.passwords = CommonEnums.password;
        this.isConfirmPassword = false;

      }
    }
  }

  removeSpace(event: any) {

    if (event.code === "Space") {
      event.preventDefault()

    }


  }

}
